module.exports = __webpack_public_path__ + "img/Recommend_dplb.9d219fe6.png";